import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

export const offerRoleValidatorGuard: CanActivateFn = () => {
	const { user } = inject(UserService);
	return user.isOfferValidator() && user.hasService('EOFFR');
};
